"use client";

import { useState } from "react";
import ReviewCard from "./ReviewCard";
import { ReviewData } from "./ReviewData";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import useUIStyles from "../../../Hooks/useUIStyles";

const ReviewSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { heading, title, description } = useUIStyles();
  const visibleReviews = 4;

  const handlePrev = () => {
    setCurrentIndex(
      prevIndex =>
        prevIndex === 0
          ? Math.max(0, ReviewData.length - visibleReviews)
          : Math.max(0, prevIndex - 1)
    );
  };

  const handleNext = () => {
    setCurrentIndex(
      prevIndex =>
        prevIndex >= ReviewData.length - visibleReviews ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4">
        <div className="mb-12">
          <h2 className="section-heading text-[28px] md:text-[32px]">
            Customer Reviews
          </h2>
          <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
            See what our customers are saying about their shopping experience
          </p>
        </div>

        {/* Enhanced Reviews Display */}
        <div className="relative">
          {/* Navigation Arrows */}
          {/* Navigation Arrows — hidden on small screens */}
          <button
            onClick={handlePrev}
            className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 z-10 bg-white rounded-full shadow-lg p-3 hover:shadow-xl transition-all duration-300 transform hover:scale-110 border border-gray-100"
            aria-label="Previous reviews"
          >
            <ChevronLeft className="w-6 h-6 text-gray-700" />
          </button>

          <button
            onClick={handleNext}
            className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 z-10 bg-white rounded-full shadow-lg p-3 hover:shadow-xl transition-all duration-300 transform hover:scale-110 border border-gray-100"
            aria-label="Next reviews"
          >
            <ChevronRight className="w-6 h-6 text-gray-700" />
          </button>
          {/* Reviews Grid */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 px-8">
            {ReviewData
              .slice(currentIndex, currentIndex + visibleReviews)
              .map(review => (
                <div key={review.id} className="group">
                  <ReviewCard review={review} />
                </div>
              ))}
          </div>

          {/* View All Reviews Link */}
          <div className="text-center mt-12">
            <a
              href="/reviews"
              className="inline-flex items-center px-8 py-3 bg-gray-900 text-white rounded-full font-semibold hover:bg-red-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl group"
              style={{ ...description }}
            >
              View All Reviews
              <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewSection;
